/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAbuse
 */
export interface ControlAbuse {
    /**
     * 
     * @type {string}
     * @memberof ControlAbuse
     */
    address: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAbuse
     */
    adversarial?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlAbuse
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAbuse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAbuse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAbuse
     */
    network: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlAbuse
     */
    ofac?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlAbuse
     */
    phone: string;
}

/**
 * Check if a given object implements the ControlAbuse interface.
 */
export function instanceOfControlAbuse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "network" in value;
    isInstance = isInstance && "phone" in value;

    return isInstance;
}

export function ControlAbuseFromJSON(json: any): ControlAbuse {
    return ControlAbuseFromJSONTyped(json, false);
}

export function ControlAbuseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAbuse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'adversarial': !exists(json, 'adversarial') ? undefined : json['adversarial'],
        'country': json['country'],
        'email': json['email'],
        'name': json['name'],
        'network': json['network'],
        'ofac': !exists(json, 'ofac') ? undefined : json['ofac'],
        'phone': json['phone'],
    };
}

export function ControlAbuseToJSON(value?: ControlAbuse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'adversarial': value.adversarial,
        'country': value.country,
        'email': value.email,
        'name': value.name,
        'network': value.network,
        'ofac': value.ofac,
        'phone': value.phone,
    };
}

